'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bookingServicesDataReceived = bookingServicesDataReceived;
exports.bookingServicesDataRequestFailed = bookingServicesDataRequestFailed;
var BOOKING_SERVICES_DATA_RECEIVED = exports.BOOKING_SERVICES_DATA_RECEIVED = 'BOOKING_SERVICES_DATA_RECEIVED';

function bookingServicesDataReceived(bookingServicesData) {
    return {
        type: BOOKING_SERVICES_DATA_RECEIVED,
        bookingServicesData: bookingServicesData
    };
}

var BOOKING_SERVICES_DATA_REQUEST_FAILED = exports.BOOKING_SERVICES_DATA_REQUEST_FAILED = 'BOOKING_SERVICES_DATA_REQUEST_FAILED';

function bookingServicesDataRequestFailed(error) {
    return {
        type: BOOKING_SERVICES_DATA_REQUEST_FAILED,
        error: error
    };
}


//////////////////
// WEBPACK FOOTER
// ./app/actions/bookingServicesActions.js
// module id = 302
// module chunks = 0